var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiaccessActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.376,
    height: 18.6,
    viewBox: "0 0 18.376 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plans_History_18px",
    "data-name": "Plans History_18px",
    transform: "translate(0.016 -0.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 18,
    height: 18,
    transform: "translate(-0.016 0.294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(1 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 17,
    height: 17,
    transform: "translate(-0.016 0.294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    d: "M5.911,8.68H9.319a.568.568,0,0,1,.568.568h0a.568.568,0,0,1-.568.568H5.911a.568.568,0,0,1-.568-.568h0A.568.568,0,0,1,5.911,8.68Z",
    transform: "translate(-3.265 -2.301)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    d: "M5.831,12.021h4.547a.532.532,0,0,1,.488.568h0s-.066.562-.488.568H5.831a.533.533,0,0,1-.488-.568h0A.533.533,0,0,1,5.831,12.021Z",
    transform: "translate(-3.265 -2.83)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(9.169 10.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M13.732,9.668a1.409,1.409,0,1,0,1.409,1.409A1.409,1.409,0,0,0,13.732,9.668Z",
    transform: "translate(-10.508 -7.853)",
    fill: "none",
    stroke: "#1450ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M15.073,9.036V5.046a.841.841,0,0,0-.841-.841H4.134a.842.842,0,0,0-.841.841V17.668a.841.841,0,0,0,.841.841H9.422",
    transform: "translate(-2.94 -1.591)",
    fill: "none",
    stroke: "#1450ff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "settings-outline",
    d: "M55.732,46.5a3.244,3.244,0,0,1-.032.437l.951.746a.227.227,0,0,1,.052.289l-.9,1.556a.227.227,0,0,1-.276.1l-.944-.38a.339.339,0,0,0-.319.037,3.458,3.458,0,0,1-.453.264.335.335,0,0,0-.185.255l-.142,1.007a.233.233,0,0,1-.225.193h-1.8a.234.234,0,0,1-.225-.187l-.141-1.006a.338.338,0,0,0-.189-.257,3.265,3.265,0,0,1-.451-.264.336.336,0,0,0-.318-.036l-.944.38a.227.227,0,0,1-.276-.1l-.9-1.556a.227.227,0,0,1,.052-.289l.8-.631a.338.338,0,0,0,.126-.3c-.008-.088-.012-.175-.012-.263s0-.174.012-.26a.336.336,0,0,0-.128-.293l-.8-.631a.227.227,0,0,1-.05-.288l.9-1.556a.227.227,0,0,1,.276-.1l.944.38a.339.339,0,0,0,.319-.037,3.459,3.459,0,0,1,.453-.264.335.335,0,0,0,.185-.255l.142-1.007A.233.233,0,0,1,51.46,42h1.8a.234.234,0,0,1,.225.187l.141,1.006a.338.338,0,0,0,.189.257,3.267,3.267,0,0,1,.451.264.336.336,0,0,0,.318.036l.944-.38a.227.227,0,0,1,.276.1l.9,1.556a.227.227,0,0,1-.052.289l-.8.631a.337.337,0,0,0-.127.3C55.727,46.325,55.732,46.412,55.732,46.5Z",
    transform: "translate(-40.001 -32.706)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiaccessActiveIcon);
export default __webpack_public_path__ + "static/media/apiaccess-active-icon.2745761fd30e47fa3eddc4d69e5ffb69.svg";
export { ForwardRef as ReactComponent };